var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    // ResizableMixin
    'image-thumbnail-crop-frame',
    // Crop
    'overflow-hidden',
    // Center
    'flex',
    'items-center',
    'justify-center',
    _setup.bgColorClass,
  ],style:({
    ..._setup.overflowBorderRadiusStyle,
    width: _setup.dimensions.cropFrameWidthString,
    height: _setup.dimensions.cropFrameHeightString,
    'background-color': _vm.placeholderColorValue,
  }),attrs:{"data-aspect-ratio":_setup.dimensions.cropFrameAspectRatio}},[(!_setup.error)?_c(_setup.BaseImage,{class:[
      // ResizableMixin
      'image-thumbnail-image',
      _vm.flipDirection === 'horizontal' && 'scale-x-[-1]',
      _vm.flipDirection === 'vertical' && 'scale-y-[-1]',
    ],style:(_vm.resizeStrategy === 'fit'
        ? {
            width: _setup.dimensions.imageElementWidthString,
            height: _setup.dimensions.imageElementHeightString,
            objectFit: 'cover',
            objectPosition: _vm.objectPosition,
          }
        : {}),attrs:{"src":_setup.url,"alt":_vm.alt != undefined ? _vm.alt : _vm.title,"data-testid":_vm.dataTestid,"height":_setup.dimensions.imageElementHeight,"width":_setup.dimensions.imageElementWidth,"loading":_vm.lazyLoading ? 'lazy' : 'eager'},on:{"load":_setup.onLoad,"error":_setup.onError}}):(_vm.fallbackToPlaceholder)?_c(_setup.BaseImage,{class:[
      // ResizableMixin
      'image-thumbnail-image',
    ],style:(_vm.resizeStrategy === 'fit'
        ? {
            width: _setup.dimensions.imageElementWidthString,
            height: _setup.dimensions.imageElementHeightString,
            objectFit: 'cover',
          }
        : {}),attrs:{"src":_setup.errorPlaceholderImage,"alt":_vm.alt != undefined ? _vm.alt : _vm.title,"data-testid":_vm.dataTestid,"height":_setup.dimensions.imageElementHeight,"width":_setup.dimensions.imageElementWidth,"loading":_vm.lazyLoading ? 'lazy' : 'eager'}}):_c('p',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }